import type { FC } from 'react';
import {
  Tab,
  TabList,
  TabListProps,
  TabPanel,
  TabPanelProps,
  TabPanels,
  TabPanelsProps,
  TabProps,
} from '@chakra-ui/react';
import { useNavigate } from 'react-router';

export type QTabProps = TabProps;

export const QTab: FC<QTabProps> = (props) => <Tab {...props} />;
QTab.displayName = 'QTab';

export type QTabPanelProps = TabPanelProps;

export const QTabPanel: FC<QTabPanelProps> = (props) => <TabPanel {...props} />;

export type QTabListProps = TabListProps;

export const QTabList: FC<QTabListProps> = (props) => <TabList {...props} />;

export type QTabPanelsProps = TabPanelsProps;

export const QTabPanels: FC<QTabPanelsProps> = (props) => (
  <TabPanels {...props} />
);

export type QRouteTabProps = Pick<QTabProps, 'children' | 'isDisabled'> & {
  destination: string;
};

export const QRouteTab: FC<QRouteTabProps> = ({ destination, ...rest }) => {
  const navigate = useNavigate();
  return <QTab onClick={() => navigate(destination)} {...rest} />;
};
QRouteTab.displayName = 'QRouteTab';
